var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"h5",class:_vm.classObject,on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_vm._t("title")],2),(_vm.isCollapsed)?_vm._t("content"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }